var _path, _linearGradient, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8WasherFluid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ccd8dc",
    d: "M47.55,27.77l-4.28,6.04l-5.79,8.17C37.01,42.64,36.26,43,35.49,43c-0.31,0-0.62-0.06-0.92-0.18 C32.75,42.11,29.39,41.2,24,41.2s-8.75,0.91-10.57,1.62c-0.3,0.12-0.61,0.18-0.92,0.18c-0.77,0-1.52-0.36-1.99-1.02l-5.79-8.17 l-4.28-6.04c-0.61-0.86-0.6-2.03,0.04-2.88C5.38,18.3,12.56,14,24,14s18.62,4.3,23.51,10.89C48.15,25.74,48.16,26.91,47.55,27.77z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Z2LcDEy0AQHRN48Wd~Jsa",
    x1: 24,
    x2: 24,
    y1: 32.187,
    y2: 39.601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a5f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007bdc"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#_Z2LcDEy0AQHRN48Wd~Jsa)",
    d: "M43.27,33.81l-5.79,8.17C37.01,42.64,36.26,43,35.49,43c-0.31,0-0.62-0.06-0.92-0.18 C32.75,42.11,29.39,41.2,24,41.2s-8.75,0.91-10.57,1.62c-0.3,0.12-0.61,0.18-0.92,0.18c-0.77,0-1.52-0.36-1.99-1.02l-5.79-8.17 C5.11,33.92,5.55,34,6,34c1.66,0,3-1,3-1s1.34,1,3,1s3-1,3-1s1.34,1,3,1s3-1,3-1s1.34,1,3,1s3-1,3-1s1.34,1,3,1s3-1,3-1s1.34,1,3,1 s3-1,3-1s1.34,1,3,1C42.45,34,42.89,33.92,43.27,33.81z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#009de4",
    d: "M24,32c-0.4,0-0.78-0.16-1.061-0.44c-0.29-0.29-0.439-0.66-0.439-1.06c0-0.391,0.16-0.78,0.439-1.061 c0.07-0.069,0.141-0.13,0.23-0.189c0.08-0.05,0.17-0.101,0.26-0.141c0.09-0.029,0.18-0.06,0.28-0.079c0.479-0.091,1,0.06,1.35,0.409 c0.28,0.28,0.44,0.67,0.44,1.061c0,0.399-0.16,0.77-0.44,1.06C24.78,31.84,24.399,32,24,32z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#009de4",
    d: "M22.5,25.33c0-0.83,0.67-1.5,1.5-1.5l0,0c0.83,0,1.5,0.67,1.5,1.5l0,0c0,0.83-0.67,1.5-1.5,1.5l0,0 C23.17,26.83,22.5,26.16,22.5,25.33z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#009de4",
    d: "M22.5,20.16c0-0.83,0.67-1.5,1.5-1.5l0,0c0.83,0,1.5,0.67,1.5,1.5l0,0c0,0.83-0.67,1.5-1.5,1.5l0,0 C23.17,21.66,22.5,20.99,22.5,20.16z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#009de4",
    d: "M22.5,14.99c0-0.83,0.67-1.5,1.5-1.5l0,0c0.83,0,1.5,0.67,1.5,1.5l0,0c0,0.819-0.67,1.5-1.5,1.5l0,0 C23.17,16.49,22.5,15.81,22.5,14.99z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#009de4",
    d: "M23.84,11.3c-0.82-0.15-1.36-0.93-1.21-1.75l0,0c0,0,0,0,0,0.01l0,0c0.15-0.819,0.93-1.359,1.74-1.21 l0,0c0.819,0.15,1.359,0.931,1.21,1.74l0,0c-0.13,0.729-0.761,1.229-1.471,1.229l0,0C24.02,11.319,23.93,11.31,23.84,11.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#009de4",
    d: "M34.68,8.3c-0.45-0.7-0.25-1.63,0.45-2.07l0,0c0.7-0.449,1.63-0.25,2.07,0.45l0,0 c0.449,0.7,0.25,1.62-0.45,2.07l0,0c-0.25,0.16-0.53,0.24-0.811,0.24l0,0C35.45,8.99,34.97,8.74,34.68,8.3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#009de4",
    d: "M25.62,6.45c-0.471-0.69-0.29-1.62,0.399-2.08l0,0C26.7,3.899,27.64,4.08,28.1,4.77l0,0 c0.46,0.681,0.29,1.62-0.399,2.08l0,0c-0.261,0.17-0.551,0.26-0.841,0.26l0,0C26.38,7.109,25.91,6.88,25.62,6.45z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#009de4",
    d: "M31.49,6.1c-0.811-0.17-1.33-0.96-1.16-1.77l0,0C30.49,3.52,31.29,3,32.1,3.16l0,0 c0.811,0.17,1.33,0.96,1.17,1.779l0,0c-0.149,0.7-0.779,1.19-1.47,1.19l0,0C31.7,6.13,31.6,6.12,31.49,6.1z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#009de4",
    d: "M36.97,14c-0.4,0-0.78-0.16-1.06-0.44c-0.28-0.29-0.44-0.66-0.44-1.06c0-0.4,0.16-0.78,0.44-1.061 c0.55-0.56,1.56-0.56,2.12,0c0.279,0.28,0.439,0.66,0.439,1.061c0,0.399-0.16,0.77-0.439,1.06C37.75,13.84,37.37,14,36.97,14z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#009de4",
    d: "M11.25,8.75c-0.7-0.45-0.9-1.37-0.46-2.07l0,0c0.45-0.7,1.38-0.899,2.08-0.45l0,0 C13.56,6.67,13.77,7.6,13.319,8.3l0,0l0,0l0,0c-0.289,0.45-0.77,0.69-1.26,0.69l0,0C11.78,8.99,11.5,8.91,11.25,8.75z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#009de4",
    d: "M20.3,6.85c-0.69-0.46-0.87-1.399-0.4-2.08l0,0c0.46-0.689,1.391-0.87,2.08-0.399l0,0 c0.69,0.46,0.87,1.39,0.4,2.08l0,0c-0.29,0.43-0.76,0.659-1.24,0.659l0,0C20.85,7.109,20.56,7.02,20.3,6.85z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#009de4",
    d: "M14.729,4.939c-0.16-0.819,0.36-1.609,1.17-1.779l0,0C16.71,3,17.5,3.52,17.67,4.33l0,0 c0.17,0.81-0.351,1.6-1.16,1.77l0,0c-0.11,0.021-0.21,0.03-0.31,0.03l0,0C15.5,6.13,14.88,5.64,14.729,4.939z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#009de4",
    d: "M11.03,14c-0.2,0-0.391-0.04-0.58-0.11c-0.181-0.08-0.341-0.189-0.48-0.33 c-0.14-0.14-0.25-0.3-0.33-0.49C9.569,12.89,9.53,12.7,9.53,12.5c0-0.391,0.159-0.78,0.439-1.061c0.07-0.069,0.14-0.13,0.23-0.189 c0.08-0.05,0.159-0.101,0.26-0.141c0.09-0.029,0.18-0.06,0.28-0.079c0.489-0.101,1,0.06,1.35,0.409c0.28,0.28,0.44,0.67,0.44,1.061 c0,0.2-0.04,0.39-0.11,0.569c-0.08,0.19-0.19,0.351-0.33,0.49c-0.14,0.141-0.3,0.25-0.49,0.33C11.42,13.96,11.229,14,11.03,14z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8WasherFluid);
export default __webpack_public_path__ + "static/media/icons8-washer-fluid.f6e6092336f9d91cec07a6ca64e6a48e.svg";
export { ForwardRef as ReactComponent };